import { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from '#/modules/commonComponents/button';
import AppDialog from '#/modules/commonComponents/dialog/AppDialog';
import { DialogFooter } from '#/modules/commonComponents/dialog/DialogPrimitives';
import FloatingTextarea from '#/modules/commonComponents/form/FloatingTextarea';

const FmsRemarkDialogSession = ({
  open,
  onOpenChange,
  initialRemark = '',
  isPending = false,
  onSave,
  inputId,
}) => {
  const [remark, setRemark] = useState(initialRemark ?? '');

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title="更新備註"
      headerVariant="muted"
      footer={(
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            取消
          </Button>
          <Button
            type="button"
            disabled={isPending}
            onClick={() => onSave?.(remark.trim() === '' ? null : remark)}
          >
            儲存
          </Button>
        </DialogFooter>
      )}
    >
      <FloatingTextarea
        id={inputId}
        label="備註"
        value={remark}
        onChange={(event) => setRemark(event.target.value)}
      />
    </AppDialog>
  );
};

const DIALOG_PROP_TYPES = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  initialRemark: PropTypes.string,
  isPending: PropTypes.bool,
  onSave: PropTypes.func,
  inputId: PropTypes.string.isRequired,
};

FmsRemarkDialogSession.propTypes = DIALOG_PROP_TYPES;

/** 只改備註（任一狀態皆可；PATCH …/remark）。每次開啟重新以目前備註起始。 */
const FmsRemarkDialog = (props) => (
  <FmsRemarkDialogSession key={props.open ? 'open' : 'closed'} {...props} />
);

FmsRemarkDialog.propTypes = DIALOG_PROP_TYPES;

export default FmsRemarkDialog;
